<template>
  <new-modal-dialog
    visible
    persistent
    scrollable
    container-class="pa-0 pt-0"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="600"
    card-class="pa-0"
    :title="$t('label.contacts_import')"
  >
    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <p class="mb-0">
              <i18n
                path="label.import_contacts_lead_text"
                tag="p"
                class="text-secondary text-center pa-0 ma-0 pt-1 pb-0"
              >
                <a
                  href="#"
                  @click="docs('contacts?id=import-contacts')"
                >{{ $t('label.import_contacts_lead_text_documentation') }}</a>
              </i18n>
            </p>
          </v-col>
          <v-col
            class="px-4 mb-6"
            cols="12"
          >
            <vue-file-agent
              v-model="fileRecords"
              theme="list"
              :multiple="false"
              deletable
              meta
              accept="text/csv"
              max-size="3MB"
              :max-files="1"
              :help-text="$t('placeholder.file_upload')"
              :error-text="{
                type: $t('error.upload_invalid_filetype_not_csv'),
                size: $t('error.upload_file_size_exceeded_maximum_x', ['10MB']),
              }"
              @beforedelete="onBeforeDelete"
              @select="filesSelected"
            />
            <p
              v-if="lastError"
              class="py-0 my-0 mt-1 field-error-message"
            >
              {{ lastError.message }}
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <template #actions>
      <v-btn
        color="success"
        :disabled="fileRecords.length === 0 || lastError?.isCsvError"
        @click="uploadImportClicked"
      >
        {{ $t('button.start_contact_import') }}
      </v-btn>
      <v-spacer />
      <v-btn
        color="error"
        text
        @click="close()"
      >
        {{ $t('button.close') }}
      </v-btn>
    </template>
  </new-modal-dialog>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue';
import NewModalDialog from '@/components/dialogs/NewModalDialog.vue';
import httpClient from '@/api/http-client';
import { useToast } from '@/components/helpers/vue2-helpers';
import i18nn from '@/plugins/i18n';
import { ApiError } from '@/api/api-error';
import useDocs from '@/components/composable/docs';
import { performDispatchAction } from '@/services/vue-utils';

const docs = useDocs();

interface UploadedFile {
  file: File;
}

const props = defineProps({});

const emit = defineEmits(['close']);

const fileRecords = ref([] as UploadedFile[]);
const toast = useToast();

function close() {
  emit('close');
}

const lastError = ref(undefined as ApiError | undefined);

const onBeforeDelete = (fileRecord: UploadedFile) => {
  lastError.value = undefined;
  fileRecords.value = [];
};

const filesSelected = () => {
  lastError.value = undefined;
};

const uploadImportClicked = () => {
  httpClient.importContacts(fileRecords.value[0].file)
    .then((response: string) => {
      toast.success(i18nn.t('message.contact_import_successful'));
      console.log(response);
      fileRecords.value = [];
    }).then(() => {
      performDispatchAction('loadGuestbook', {}, { streamLoad: true });
    })
    .catch((error) => {
      const apiError = ApiError.fromError(error);
      lastError.value = apiError;
      toast.error(i18nn.t('error.contact_import_failed'));
      console.error(apiError);
    });
};

</script>
